import { render, staticRenderFns } from "./logout-button.vue?vue&type=template&id=2b2d11a9&"
import script from "./logout-button.vue?vue&type=script&lang=js&"
export * from "./logout-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports